export default "#progress-bar-status{width:100%;height:100%}";